import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { Link } from "react-navi";
import { encodeUrlParams } from "../../services/utils";
/**
 *  Returns a paginator based on the endpoint (example /templates, /machines etc..)
 * and the pages info (the object returned by the paginate() method in the lucid models)
 */
function Paginator(props) {
  const { pages: pagesInfo, params } = props;
  let { endpoint } = props;

  // If there are no pages then don't render anything
  if (pagesInfo.total === 0) return null;

  // if the endpoint already includes a "?" it means there are query params present
  // otherwise just append it
  endpoint = endpoint.includes("?") ? `${endpoint  }&` : `${endpoint  }?`;

  if (params) {
    endpoint += `${encodeUrlParams(params)  }&`;
  }
  const pages = [];

  // Adding the "<<" arrow that returns to the first page
  pages.push(
    <PaginationItem>
      <PaginationLink
        className="pagelink"
        tag={Link}
        first
        href={`/${  endpoint  }page=1`}
      />
    </PaginationItem>
  );

  // Adding the "<" arrow that returns to the previous page
  // If we're on the first page then we should not increment
  const previousPage =
    parseInt(pagesInfo.page, 10) > 1 ? parseInt(pagesInfo.page, 10) - 1 : 1;
  pages.push(
    <PaginationItem>
      <PaginationLink
        className="pagelink"
        tag={Link}
        previous
        href={`/${  endpoint  }${"page=".concat(previousPage)}`}
      />
    </PaginationItem>
  );

  // Adding all page numbers
  for (let j = 1; j <= pagesInfo.lastPage; j++) {
    // If it's the current link then paginationitem should have the active flag
    // and the paginationlink should have the "page-link-active" classname
    if (parseInt(pagesInfo.page, 10) === j)
      pages.push(
        <PaginationItem active>
          <PaginationLink
            className="page-link-active"
            tag={Link}
            previous
            href={`/${  endpoint  }${"page=".concat(j)}`}
          >
            {j}
          </PaginationLink>
        </PaginationItem>
      );
    else {
      // else push a regular component
      pages.push(
        <PaginationItem>
          <PaginationLink
            className="page-link"
            tag={Link}
            previous
            href={`/${  endpoint  }${"page=".concat(j)}`}
          >
            {j}
          </PaginationLink>
        </PaginationItem>
      );
    }
  }
  // Adding the ">" arrow that moves to the next page
  // if we're on the last page then we should not increment
  const nextPage =
    parseInt(pagesInfo.page, 10) < parseInt(pagesInfo.lastPage, 10)
      ? parseInt(pagesInfo.page, 10) + 1
      : parseInt(pagesInfo.lastPage, 10);
  pages.push(
    <PaginationItem>
      <PaginationLink
        className="pagelink"
        tag={Link}
        next
        href={`/${  endpoint  }${"page=".concat(nextPage)}`}
      />
    </PaginationItem>
  );

  // Adding the ">>" arrow that moves to the last page
  pages.push(
    <PaginationItem>
      <PaginationLink
        className="pagelink"
        tag={Link}
        last
        href={`/${  endpoint  }${"page=".concat(pagesInfo.lastPage)}`}
      />
    </PaginationItem>
  );

  return (
    <Pagination className="d-flex justify-content-center">{pages}</Pagination>
  );
}

export default Paginator;



// WEBPACK FOOTER //
// ./src/views/components/Paginator.jsx